<div class="seperator"></div>
<div class="title" mat-dialog-title>
    Enable GumGum
    <img class="logo" src="https://rubii-images.s3-ap-southeast-2.amazonaws.com/dsp/gumgum.svg" alt="GumGum" />
</div>
<div class="gmail-body">
    <div style="text-align: left;">
        <div>Please schedule a daily report and send to below email: </div>
        <div class="report-email-container">
            <div style="font-weight: 600;">Recipient email address</div>
            <div class="ias-email">
                <div>{{ xyzEmail }}</div>  
                <button mat-icon-button (click)="copyMessageToClipboard(xyzEmail)">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>
        <!-- TODO:change template url -->
        <div class="ias-template-link" style="display: none;"><a href="https://rubii-images.s3-ap-southeast-2.amazonaws.com/templates/ias-template.xlsx"
                target="_blank" data-cy="ias-template-link"> Download a sample report </a>
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
    </div>
</div>
